import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './components/main';
import SpendinglyPrivacyPolicy from './components/SpendinglyPrivacyPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Main />} />
         <Route path="/spendingly-privacy-policy" element={<SpendinglyPrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;

